"use strict";

import angular from "angular";

import template from "./menu-items.component.html";

class MenuItemsComponent {
    constructor() {}

    $onInit() {}
}

export { MenuItemsComponent };

MenuItemsComponent.$inject = [];

const name = "menuItemsComponent";
const def = {
    controller: MenuItemsComponent,
    bindings: { icon: "@", items: "<", onClickItem: "&", itemActive: "<" },
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
